import { RouteItemType } from '~/core/router';
import { withAuthAnalyticsLayout } from '~/decorators/withLayout';
import lazyComponentLoader from '~/helpers/lazyComponentLoader';
import {
  ForgotPasswordPath,
  getForgotPasswordTitle,
  getResetPasswordTitle,
  getSignInTitle,
  getSignUpTitle,
  ResetPasswordPath,
  SignInPath,
  SignUpPath,
} from '~/modules/auth/constants';

const SignIn = lazyComponentLoader(() => import('./components/SignIn'));
const SignUp = lazyComponentLoader(() => import('./components/SignUp'));
const ForgotPassword = lazyComponentLoader(
  () => import('./components/ForgotPassword'),
);
const ResetPassword = lazyComponentLoader(
  () => import('./components/ResetPassword'),
);

export const SignInRoute: RouteItemType = {
  Component: withAuthAnalyticsLayout(SignIn),
  path: SignInPath,
  getTitle: getSignInTitle,
};

export const SignUpRoute: RouteItemType = {
  Component: withAuthAnalyticsLayout(SignUp),
  path: SignUpPath,
  getTitle: getSignUpTitle,
};
export const ForgotPasswordRoute: RouteItemType = {
  Component: withAuthAnalyticsLayout(ForgotPassword),
  path: ForgotPasswordPath,
  getTitle: getForgotPasswordTitle,
};

export const ResetPasswordRoute: RouteItemType = {
  Component: withAuthAnalyticsLayout(ResetPassword),
  path: ResetPasswordPath,
  getTitle: getResetPasswordTitle,
};
